<script setup lang="ts">
import type { DeviceModel } from '@/types/models/DeviceModel'
import type { PermissionsEnums } from '@/types/permissions/PermissionsEnum'
import { computed, ref } from 'vue'
import DeleteDeviceNameInput from '../../../../views/AdministrationView/Device/components/DeleteDeviceNameInput.vue'
import ActionsColumnComponent from '../../../Table/components/ActionsColumnComponent.vue'

type Props = {
    deletePermission?: PermissionsEnums
    editPermission?: PermissionsEnums

    editButtonHref?: string
    hrefKey?: string
    row: Record<string, string>
}

const props = defineProps<Props>()
type Emits = {
    (e: 'goTo', data: any): void
    (e: 'click', device: DeviceModel): void
    (e: 'delete', device: DeviceModel): void
}
const emit = defineEmits<Emits>()

const goTo = (device: DeviceModel) => emit('click', device)

const deviceName = ref<string>()
const isNameSimilar = computed(() => deviceName.value === props.row?.name)
</script>

<template>
    <ActionsColumnComponent
        @goTo="goTo"
        @delete="emit('delete', $event)"
        :disabled="!isNameSimilar"
        :deletePermission="deletePermission"
        :editPermission="editPermission"
        :editButtonHref="editButtonHref"
        :hrefKey="hrefKey"
        :row="row">
        <template #confirmationDialog>
            <DeleteDeviceNameInput :name="deviceName" @change="deviceName = $event" />
        </template>
    </ActionsColumnComponent>
</template>
